import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperTransactionStatesComponent } from './stepper-transaction-states.component';
import { MatCardModule } from '@angular/material/card';
import { StepperStateElementModule } from './stepper-state-element/stepper-state-element.module';
import { SlideModule } from '@app/core/components/slide/slide.module';

@NgModule({
    declarations: [StepperTransactionStatesComponent],
    exports: [StepperTransactionStatesComponent],
    imports: [CommonModule, MatCardModule, StepperStateElementModule, SlideModule]
})
export class StepperTransactionStatesModule {}
